import { financialSheetsAllowedRoles } from '~/features/financial-sheets/shared/financial-sheets-allowed-roles';
import { useRoleGuard } from '~/common/providers/auth/use-role-guard';

/** 一覧はレポートを閲覧できるロールに開く（遷移先のレポート本体の閲覧権に揃える） */
const reportCommentsAllowedRoles = financialSheetsAllowedRoles;

/**
 * コメント一覧へアクセスできるか。
 *
 * ヘッダーの導線と一覧ページのガードで同じ条件を使う。条件を2箇所へ書くと、
 * 片方だけ直したときに「アイコンは出るが開くと権限エラーだけが出る」状態になるため、ここに集約する。
 */
const useReportCommentsAccess = (): boolean => {
  return useRoleGuard(reportCommentsAllowedRoles);
};

export { reportCommentsAllowedRoles, useReportCommentsAccess };
